<template>
  <div class="devOpsRepory mainPageBg">
    <AnalysisHead @getActiveTime="getActiveTime"
      :showDownload="judgeAuthority('baobiao:devOpsReport:export')" />
    <div class="contentBox">
      <div class="leftBox ashComWrap">
        <div class="comTitle">
          <h4>工单</h4>
        </div>
        <div class="comContentBox">
          <div style="width: 100%; height: 45%; display: flex">
            <div style="width: 50%; height: 90%">
              <PublicEcharts :id="'pie1'"
                :chartsData="wordOrderData"
                :type="'pieChart'" />
            </div>
            <div style="width: 50%; height: 90%">
              <PublicEcharts :id="'ring1'"
                :chartsData="sourceData"
                :type="'ringChart'" />
            </div>
          </div>
          <div style="width: 100%; height: 55%">
            <PublicEcharts :id="'overview'"
              :chartsData="systemChart"
              :type="'stackedBar'" />
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div class="rightTop ashComWrap">
          <div class="comTitle">
            <h4>报警</h4>
          </div>
          <div class="comContentBox"
            style="display: flex">
            <div style="width: 45%; height: 90%">
              <PublicEcharts :id="'pie2'"
                :chartsData="alarmData"
                :type="'pieChart'" />
            </div>
            <div style="width: 55%; height: 100%">
              <PublicEcharts :id="'overview1'"
                :chartsData="alarmChart"
                :type="'stackedBar'" />
            </div>
          </div>
        </div>
        <div class="rightBottom">
          <div class="inspection ashComWrap">
            <div class="comTitle">
              <h4>巡检</h4>
            </div>
            <div class="comContentBox">
              <ul class="txtBox">
                <li>
                  <h5>{{inspection.planCount}}</h5>
                  <p>执行巡检计划</p>
                </li>
                <li>
                  <h5>{{inspection.deviceCount}}</h5>
                  <p>巡检点位/区域</p>
                </li>
              </ul>
              <div class="chartBox">
                <PublicEcharts :id="'pie3'"
                  :chartsData="gradeData"
                  :type="'pieChart'" />
              </div>
            </div>
          </div>
          <div class="maintainAcleaning">
            <div class="maintain ashComWrap">
              <div class="comTitle">
                <h4>保养</h4>
              </div>
              <div class="comContentBox">
                <ul class="txtBox"
                  style="height: 100%">
                  <li>
                    <h5>{{maintain.planCount}}</h5>
                    <p>执行保养计划</p>
                  </li>
                  <li>
                    <h5>{{maintain.deviceCount}}</h5>
                    <p>保养设备数量</p>
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div class="cleaning ashComWrap">
              <div class="comTitle">
                <h4>保洁</h4>
              </div>
              <div class="comContentBox">
                <ul class="txtBox"
                  style="height: 100%">
                  <li>
                    <h5>32</h5>
                    <p>执行保养计划</p>
                  </li>
                  <li>
                    <h5>976</h5>
                    <p>保洁区域/房间</p>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import PublicEcharts from "@/components/PublicEcharts";
import { exportDevOpsReportWord } from "@/assets/utils/exportWord";
import api from "@/api";
import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderSource,
  matchingAlarmLevel,
  judgeAuthority,
  matchingInspectionCycle,
} from "@/assets/js/utils";
export default {
  components: {
    AnalysisHead,
    PublicEcharts,
  },
  data() {
    return {
      gradeData: {
        dataArr: [],
      },
      wordOrderData: {
        pieTitle: "",
        dataArr: [],
      },
      sourceData: {
        unit: "",
        dataArr: [],
      },
      systemChart: {
        unit: "条",
        yData: [],
        dataArr: [],
      },
      alarmData: {
        pieTitle: "",
        dataArr: [],
      },
      alarmChart: {
        unit: "条",
        yData: [],
        dataArr: [],
      },
      maintain: {
        planCount: null,
        deviceCount: null,
      },
      inspection: {
        planCount: null,
        deviceCount: null,
      },
      headData: {},
      wordOrderTable: [],
      alarmTable: [],
    };
  },
  methods: {
    judgeAuthority,
    exportWord() {
      let data = {
        title: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0]
          .projectName,
        time:
          this.headData.type == "UNLIMITED"
            ? "全部"
            : this.headData.type == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.headData.timeValue))
            : dateFtt("yyyy年", new Date(this.headData.timeValue)),
        wordOrderData: this.wordOrderData.dataArr,
        sourceData: this.sourceData.dataArr,
        wordOrderTable: this.wordOrderTable,
        alarmData: this.alarmData.dataArr,
        alarmTable: this.alarmTable,
        gradeData: this.gradeData.dataArr,
        maintain: [
          { name: "执行保养计划", value: this.maintain.planCount },
          { name: "保养设备数量", value: this.maintain.deviceCount },
        ],
      };
      exportDevOpsReportWord(data);
    },
    getActiveTime(val) {
      this.headData = val;
      // console.log(val);
      this.getWorkOrderOverview(val);
      this.getSource(val);
      this.getSystem(val);
      this.getAlarmData(val);
      this.getAlarmSystem(val);
      this.getInspectionCharts(val); //巡检
      this.getData(val); //保养
    },
    /****  工单  *** */
    async getWorkOrderOverview(data) {
      this.wordOrderData.pieTitle = "";
      this.wordOrderData.dataArr = [];

      let res = await api.logisticsWOANALOverview({
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.wordOrderData.pieTitle = res.data.data.num;
        this.wordOrderData.dataArr = Array.from(res.data.data.charts).map(
          (item) => ({
            name: matchingOrderLevel(item.name),
            value: item.value,
          })
        );
      }
    },
    async getSource(data) {
      this.sourceData.unit = "";
      this.sourceData.dataArr = [];
      let res = await api.logisticsWOANALSource({
        type: data.type,
        date: data.timeValue,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.sourceData.dataArr = Array.from(res.data.data).map((item) => ({
          name: matchingOrderSource(item.name),
          value: item.value,
        }));
        this.sourceData.unit = this.sourceData.dataArr[0].unit ?? "";
      }
    },
    async getSystem(data) {
      this.systemChart.yData = [];
      this.systemChart.dataArr = [];
      this.wordOrderTable = [];
      let res = await api.logisticsWOANALSystem({
        type: data.type,
        date: data.timeValue,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.slice(0, 5).map((v, i) => {
          this.systemChart.yData.push(v.name);
          arr.push(v.charts);
          this.wordOrderTable.push({
            name: v.name,
          });
          v.charts.map((item) => {
            let newObj = {};
            let variable = item.name;
            newObj[variable] = item.value;
            this.wordOrderTable[i] = Object.assign(
              this.wordOrderTable[i],
              newObj
            );
          });
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.systemChart.dataArr.push({ name: "", data: [] });
          arr.map((item) => {
            this.systemChart.dataArr[i].name = matchingOrderLevel(item[i].name);
            this.systemChart.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },

    /****  告警  *** */
    async getAlarmData(data) {
      this.alarmData.dataArr = [];
      this.alarmData.pieTitle = null;
      let res = await api.getSAlarmAnalysis({
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        let objData = res.data.data;
        this.alarmData.pieTitle = objData.overview.find((v) => {
          return v.name == "报警总数";
        }).value;
        let arr = objData.alarmLevelAnalysis.filter((v) => {
          return v.name == "CRITICAL" || v.name == "MAJOR" || v.name == "MINOR";
        });
        this.alarmData.dataArr = Array.from(arr).map((item) => ({
          name: matchingAlarmLevel(item.name),
          value: item.value,
        }));
      }
    },
    async getAlarmSystem(data) {
      this.alarmChart.yData = [];
      this.alarmChart.dataArr = [];
      this.alarmTable = [];
      let res = await api.formDevOpsAlarmSystem({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        label: "区域位置",
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.slice(0, 5).map((v, i) => {
          this.alarmChart.yData.push(v.name);
          this.alarmTable.push({ name: v.name });
          let newArr = [];
          v.charts.map((item) => {
            for (let key in item) {
              if (key == "CRITICAL" || key == "MAJOR" || key == "MINOR") {
                newArr.push({
                  name: matchingAlarmLevel(key),
                  value: item[key],
                });
              }
            }
            this.alarmTable[i] = Object.assign(this.alarmTable[i], item);
          });
          arr.push(newArr);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.alarmChart.dataArr.push({ name: "", data: [] });
          arr.map((item) => {
            this.alarmChart.dataArr[i].name = item[i].name;
            this.alarmChart.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },
    // 巡检/保养
    async getData(data) {
      this.maintain.planCount = null;
      this.maintain.deviceCount = null;
      let res = await api.formDevOpsMaintenanceInspection({
        sourceType: "MAINTENANCE",
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.maintain.planCount = res.data.data.planCount;
        this.maintain.deviceCount = res.data.data.deviceCount;
      }
    },
    async getInspectionCharts(data) {
      this.gradeData.dataArr = [];
      this.inspection.planCount = null;
      this.inspection.deviceCount = null;
      let res = await api.formDevOpsInspectionCharts({
        sourceType: "INSPECTION",
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.inspection.planCount = res.data.data.planCount;
        this.inspection.deviceCount = res.data.data.deviceCount;
        this.gradeData.dataArr = Array.from(res.data.data.charts).map(
          (item) => ({
            name: matchingInspectionCycle(item.name),
            value: item.value,
          })
        );
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.devOpsRepory {
  .contentBox {
    width: $innerWidth;
    height: calc(100% - 105px);
    margin: 0 auto;
    @include setFlexBetween;
    .leftBox {
      width: $halfWidth;
      height: 100%;
    }
    .rightBox {
      width: $halfWidth;
      height: 100%;
      .rightTop {
        width: 100%;
        height: $halfWidth;
        margin-bottom: 2%;
      }
      .rightBottom {
        width: 100%;
        height: $halfWidth;
        @include setFlexBetween;
        .txtBox {
          width: 100%;
          height: 40%;
          @include setFlexBetween;
          li {
            width: 50%;
            text-align: center;
            h5 {
              font-size: 28px;
            }
          }
        }
        .inspection {
          width: 50%;
          height: 100%;
          .chartBox {
            width: 100%;
            height: 60%;
          }
        }
        .maintainAcleaning {
          width: 49%;
          height: 100%;
          .maintain {
            width: 100%;
            height: 49%;
            margin-bottom: 2%;
          }
          .cleaning {
            width: 100%;
            height: 49%;
          }
        }
      }
    }
  }
}
</style>